import { RootState } from 'store/rootReducer';

export const RegistrationEmailContentSelector = (state: RootState) => state.content.registrationEmail;
